import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aea2c3ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "placeholder", "disabled", "maxlength", "cols", "rows", "readonly"]
const _hoisted_2 = ["value", "placeholder", "type", "maxlength", "disabled", "readonly"]
const _hoisted_3 = { class: "slot" }
const _hoisted_4 = {
  key: 0,
  class: "show-psd"
}

import { toRefs, ref } from 'vue';
  import BaseIcon from '../../BaseIcon/src/BaseIcon.vue';
  
  import { isIos } from '@/utils/is';
  import { isIOS } from 'vant/lib/utils';
  import { computed, defineComponent } from 'vue';
  const __default__ = defineComponent({
    name: 'BaseInput',
  });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    maxlength: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
    cols: {
      type: Number,
      default: 20,
    },
    rows: {
      type: Number,
      default: 3,
    },
  },
  emits: ['update:modelValue', 'input', 'focus', 'blur'],
  setup(__props, { emit }) {

const props = __props

  
  const { icon, disabled, loading, showPassword, type, modelValue } = toRefs(props);
  
  function handleInput(ev) {
    emit('update:modelValue', ev.target.value);
    emit('input', ev);
  }
  const isFocus = ref(false);
  let isFromIos = false;
  function handleFocus(ev) {
    if (disabled.value) {
      isFromIos = true;
      handleBlur();
    }
    emit('focus', ev);
    if (!isIOS()) {
      isFocus.value = true;
    }
  }

  const realDisabled = computed(() => {
    if (isIos()) {
      return false;
    }
    return disabled.value || loading.value;
  });
  const realIcon = computed(() => (loading.value ? 'loading' : icon.value));
  function handleBlur(ev?: any) {
    if (isFromIos) {
      isFromIos = false;
      return;
    }
    emit('blur', ev);
    isFocus.value = false;
  }
  const isShowPsd = ref(false);
  const PASSWORD = 'password';
  const isPassword = computed(() => type.value == PASSWORD);
  const originType = computed(() => {
    if (typeof modelValue.value == 'number' && type.value == 'text') {
      return 'tel';
    }
    if (isPassword.value == false) {
      return type.value;
    } else {
      if (showPassword.value == true) {
        return isShowPsd.value ? 'text' : 'password';
      } else {
        return type.value;
      }
    }
  });
  function handleShowPsd() {
    isShowPsd.value = !isShowPsd.value;
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'base-input',
      'base',
      {
        'primary-border': isFocus.value,
        'danger-border': __props.error,
        light: __props.light,
      },
      _unref(originType),
    ])
  }, [
    (_unref(originType) == 'textarea')
      ? (_openBlock(), _createElementBlock("textarea", {
          key: 0,
          id: "",
          class: "textarea inner",
          value: _unref(modelValue),
          placeholder: __props.placeholder,
          disabled: _unref(realDisabled),
          maxlength: __props.maxlength,
          cols: __props.cols,
          rows: __props.rows,
          readonly: _unref(realDisabled),
          onInput: handleInput,
          onFocus: handleFocus,
          onBlur: handleBlur
        }, null, 40, _hoisted_1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(icon))
            ? (_openBlock(), _createBlock(BaseIcon, {
                key: 0,
                color: "#c4c4c4",
                class: "base-input-icon",
                name: _unref(realIcon)
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            class: "base-input-container inner",
            value: _unref(modelValue),
            placeholder: __props.placeholder,
            type: _unref(originType),
            maxlength: __props.maxlength,
            disabled: _unref(realDisabled),
            readonly: _unref(disabled),
            onInput: handleInput,
            onFocus: handleFocus,
            onBlur: handleBlur
          }, null, 40, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            (_unref(isPassword) && _unref(showPassword))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(BaseIcon, {
                    name: !isShowPsd.value ? 'hide_password' : 'show_password',
                    onClick: handleShowPsd
                  }, null, 8, ["name"])
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 64))
  ], 2))
}
}

})